import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { JobsService } from '@app/shared/jobs.service';
import { Division } from '@app/shared/shared.models';

@Component({
  selector: 'app-home-career-oportunities',
  templateUrl: './career-oportunities.component.html',
  styleUrls: ['./career-oportunities.component.css'],
})
export class CareerOportunitiesComponent implements OnInit {
  dedicated = {} as Division;
  intermodal = {} as Division;
  noCdl = {} as Division;
  otr = {} as Division;

  constructor(private jobsService: JobsService, private router: Router) {}

  ngOnInit() {
    this.jobsService.divisions().then((apiDivisions) => {
      this.dedicated = apiDivisions.find((c) => c.JobType === 'DEDICATED');
      this.intermodal = apiDivisions.find((c) => c.JobType === 'INTERMODAL');
      this.noCdl = apiDivisions.find((c) => c.JobType === 'NO_CDL');
      this.otr = apiDivisions.find((c) => c.JobType === 'OVER_THE_ROAD');
    });
  }
}
